/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressDtoFromJSON, AddressDtoToJSON, } from './';
export function CustomerRequestFromJSON(json) {
    return CustomerRequestFromJSONTyped(json, false);
}
export function CustomerRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'customerId': !exists(json, 'customerId') ? undefined : json['customerId'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'additionalEmail': !exists(json, 'additionalEmail') ? undefined : json['additionalEmail'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'phoneNumberPrefix': !exists(json, 'phoneNumberPrefix') ? undefined : json['phoneNumberPrefix'],
        'additionalPhone': !exists(json, 'additionalPhone') ? undefined : json['additionalPhone'],
        'additionalPhoneNumberPrefix': !exists(json, 'additionalPhoneNumberPrefix') ? undefined : json['additionalPhoneNumberPrefix'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'isCompany': !exists(json, 'isCompany') ? undefined : json['isCompany'],
        'nip': !exists(json, 'nip') ? undefined : json['nip'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'fkId': !exists(json, 'fkId') ? undefined : json['fkId'],
        'applicationUserId': !exists(json, 'applicationUserId') ? undefined : json['applicationUserId'],
        'billAddress': !exists(json, 'billAddress') ? undefined : AddressDtoFromJSON(json['billAddress']),
        'correspondenceAddress': !exists(json, 'correspondenceAddress') ? undefined : AddressDtoFromJSON(json['correspondenceAddress']),
    };
}
export function CustomerRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'customerId': value.customerId,
        'email': value.email,
        'additionalEmail': value.additionalEmail,
        'phone': value.phone,
        'phoneNumberPrefix': value.phoneNumberPrefix,
        'additionalPhone': value.additionalPhone,
        'additionalPhoneNumberPrefix': value.additionalPhoneNumberPrefix,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'isCompany': value.isCompany,
        'nip': value.nip,
        'companyName': value.companyName,
        'fkId': value.fkId,
        'applicationUserId': value.applicationUserId,
        'billAddress': AddressDtoToJSON(value.billAddress),
        'correspondenceAddress': AddressDtoToJSON(value.correspondenceAddress),
    };
}
